@use '@design/design-tokens/border-radius/border-radius' as *;

@layer chart {
  .chartTypeSelectorRoot {
    display: flex;
    @include border-radius-r2;
    padding: 4px;
    background-color: var(--surface-default);
    gap: 4px;

    > .chartTypeDropdown {
      justify-content: center;
    }
  }

  .chartTypeDropdown {
    [role='listbox'] {
      width: 272px;
      overflow-y: hidden;
    }
  }

  .styledChip {
    height: 28px;
    width: 32px;
  }
}
